export default {
  time_options: {
    asap: {
      title: 'Lo antes posible',
      description: 'Listo en {{time}} min',
    },
    scheduled: {
      title: 'Programar para más tarde',
    },
  },
};
